<template>
  <div>
    <gallery :images="images" :index="index" @close="index = null"></gallery>
    <div class="album-gallery">
      <div
        class="image"
        v-for="(image, imageIndex) in images"
        :key="imageIndex"
        @click="index = imageIndex"
        :style="{ backgroundImage: 'url(' + image + ')' }"
      ></div>
    </div>
  </div>
</template>

<script>
import VueGallery from 'vue-gallery';
export default {
  name: 'AlbumGallery',
  props: {
    images: Array,
  },
  data: function() {
    return {
      index: null,
    };
  },
  components: {
    gallery: VueGallery,
  },
};
</script>

<style lang="scss" scoped>
.album-gallery {
  display: flex;
  flex-direction: row;
}
.image {
  width: 150px;
  height: 150px;
  margin: 8px;
  background-position: center center;
  background-size: 420px 600px;
  background-repeat: no-repeat;

  border: 1px solid black;
  transition: transform 0.2s;

  &:hover {
    cursor: pointer;
    transform: scale(1.05);
  }
}
</style>
